import VueFire from "vuefire";
import firebase from "firebase/app";
import "firebase/firestore";
require("firebase/auth");

let config = {
  apiKey: "AIzaSyB_6VjrJXmDGPXUy82weBfj13SmbyDPw2c",
  authDomain: "promotool-120ef.firebaseapp.com",
  databaseURL: "https://promotool-120ef.firebaseio.com",
  projectId: "promotool-120ef",
  storageBucket: "promotool-120ef.appspot.com",
  messagingSenderId: "46361293468"
};

firebase.initializeApp(config);
const db = firebase.firestore();
const settings = {
  timestampsInSnapshots: true
};
db.settings(settings);

// to use development, set to true production = false
const dev = false;

let promotionsCollection;

if (dev === true) {
  promotionsCollection = db.collection("promotions_dev");
} else {
  promotionsCollection = db.collection("promotions");
}

export { firebase, db, promotionsCollection };



// WEBPACK FOOTER //
// ./src/firebase-config.js